module.exports = __webpack_public_path__ + "static/media/sample_cat_topeka.8821c9c9.png";